module.exports = __webpack_public_path__ + "img/personal_sale.1422441f.png";